module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_5"
    }
  }, [_c('span', [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("MY DAUGHTER—")]), _vm._v("grown—keeps adopting cats and then realizing that she lives in a tiny apartment and giving the cat to us. To this end, we have one cat—Steve—who we adopted twelve years ago and is the most feared animal in the house, and three male cats under five years old who range from psychopath to mouth breather to “I think I’ll pee here.” During the pandemic, when we were all scared and forced to endure each other’s company for way too long, those stupid furry poop-machines saved our lives. When we couldn’t talk about being afraid or being frustrated or being depressed, we could tell wild stories about whether Nebula the bird-murderer caught his quota today, or how many breaths Dewey has to take while gazing at the sky before he just flops over. We may have watched every miniseries on TV, but our house animals were a never-ending source of entertainment for us. Animals give us so much. It is an honor to be able to give them a place in the home.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34d94568","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0005.vue
// module id = 69
// module chunks = 0